export default "__VITE_ASSET__DlHN1FNx__"